import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { authAtom, phoneAtom } from '../core/config/atoms';

import { ScrollArea } from "@/components/ui/scroll-area";
import moment from 'moment';

import Lottie from 'lottie-react';
import { toast } from 'react-toastify';

import animBtnLoading from '../assets/anim/anim-btnLoading.json';

import ServiceAuth from 'services/serviceAuth';
import ServiceHelp from 'services/serviceHelp';

import bgLogin from '../assets/image/bglogin.png';
import bgW from '../assets/image/logow.png';
import icHelp from '../assets/image/helpIcon.png';

export default function PageAuth() {

    const [authStatus] = useRecoilState(authAtom);
    const [, setPhone] = useRecoilState(phoneAtom);

    const phoneRef = useRef('');

    const [help, setHelp] = useState({});

    const [submit, setSubmit] = useState(false);
    const [isHelp, setIsHelp] = useState(false);

    const navigate = useNavigate();
    const authService = new ServiceAuth();
    const helpService = new ServiceHelp();

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmit(true);
        const number = phoneRef.current.value;
        if (/^\d{10}$/.test(number)) {
            let body = {
                'phone': number
            };
            authService.userPhoneVerify(body, '').then((res) => {
                if (res.statuscode == 201) {
                    let body = {
                        "phone": number,
                        "token": ""
                    }
                    authService.userLogin(body, '').then((res) => {
                        if (res.status) {
                            toast.success("OTP Sent to registred mobile number!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                            setPhone(number);
                            gotoOTP();
                        } else {
                            toast.error(res.msg, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        }
                        setSubmit(false);
                    });
                } else {
                    setSubmit(false);
                    toast.error("User account does not exist try creating new one!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            })
        } else {
            toast.error('Enter valid phone number !', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            setSubmit(false);
        }
    }

    const gotoOTP = () => {
        navigate('/verify');
    }

    const gotoRegister = () => {
        navigate('/register');
    }

    const getHelp = (path) => {
        let body = {
            "path": path
        };
        helpService.getHelpByFilter(body, '').then((res) => {
            if (res.status) {
                setHelp(res.data);
                setIsHelp(true);
            }
        });
    }

    useEffect(() => {
        if (authStatus === 'verified') {
            navigate('/home/main');
        }
    }, [authStatus, navigate]);

    return (
        <>
            {
                isHelp && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-screen md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-full lg:w-[600px] min-h-screen absolute right-0 p-[4px] py-4 lg:p-[20px]'>
                        <ScrollArea>
                            <div className='px-4'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900'>{help.name}</h1>
                                    <span onClick={() => {
                                        setIsHelp(false);
                                        setHelp({});
                                    }}><i className="las la-times text-xl text-gray-700 cursor-pointer"></i></span>
                                </div>
                                <hr className='my-1' />
                                <div className="w-full">
                                    <div className='w-full pt-[56.25%] relative'>
                                        <video src={help.videoFile.fileurl} autoPlay playsInline loop crossOrigin="anonymous" className='border-2 border-prime rounded object-cover xl:object-fill absolute inset-0 w-full h-full'>
                                            <track label="English" kind="subtitles" src={help.srtFile.fileurl} srcLang="en" default />
                                        </video>
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <div className='m-2'>
                                    <div className='text-sm text-gray-900 ql-editor' dangerouslySetInnerHTML={{ __html: help.disc }}></div>
                                </div>
                            </div>
                        </ScrollArea>
                    </div>
                </div>
            }
            <div className="w-screen h-screen overflow-hidden relative">
                <div className="xl:grid xl:grid-cols-12 xl:gap-0">
                    <div className="absolute xl:relative w-full xl:col-span-5">
                        <div className="h-screen flex flex-col items-center justify-center xl:bg-blue-50">
                            <div className="shadow-lg rounded-xl px-4 xl:px-10 pt-6 pb-20 xl:py-10 bg-white mt-6 mx-2 max-w-md md:w-auth w-11/12">
                                <div className='w-full flex items-center justify-between'>
                                    <div>
                                        <h1 className="text-2xl text-black font-serif font-medium">User Login</h1>
                                        <h2 className="text-sm text-gray-400 font-serif">Accessible Communication for the Deaf</h2>
                                    </div>
                                    <div className='text-prime cursor-pointer' onClick={() => { getHelp('/customerLogin') }}>
                                        <img src={icHelp} alt="Help icon" className="login background w-[36px]" />
                                    </div>
                                </div>
                                <form className="mt-8" onSubmit={handleSubmit}>
                                    <div className="flex flex-col">
                                        <label className="text-sm text-gray-900 font-serif">Mobile number
                                            <sup className="text-red-600">*</sup>
                                        </label>
                                        <input type="off" placeholder="i.e. 123456789" className="w-full h-11 rounded bg-blue-50 px-4 py-2 text-sm font-sans mt-1" required autoComplete="off" ref={phoneRef} />
                                    </div>
                                    <button type="submit" className="mt-8 text-xs font-bold text-white rounded bg-prime hover:bg-primeLight w-full h-10 font-mono flex items-center justify-center" disabled={submit}>
                                        {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" />}
                                        {!submit && "LOGIN"}
                                    </button>
                                    <div className='flex items-center mt-4'>
                                        <div className='w-[80px] h-[1px] bg-gray-600'></div>
                                        <p className='text-sm text-center mx-auto font-medium'>Don't have an account</p>
                                        <div className='w-[80px] h-[1px] bg-gray-600'></div>
                                    </div>
                                    <button type="button" className="mt-4 text-xs font-bold text-white rounded bg-primeLight w-full h-10 font-mono flex items-center justify-center" onClick={() => {
                                        gotoRegister();
                                    }}>
                                        REGISTER
                                    </button>
                                </form>
                                <div id="captcha"></div>
                                <div className="flex-grow"></div>
                                <p className="text-sm text-gray-400 font-serif text-center mt-16">&copy; {moment().format('yyyy')} India Signing Hands Private Limited.</p>
                                <div className='flex mt-2 items-center justify-between text-sm text-gray-600 underline'>
                                    <div className='cursor-pointer' onClick={() => { getHelp("/termsConditions") }}>Terms & Conditions</div>
                                    <div className='cursor-pointer' onClick={() => { getHelp("/privacyPolicy") }}>Privacy Policy </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="h-screen xl:col-span-7 bg-gradient-to-b from-[#2c499e] to-[#00aed0] flex items-start justify-center xl:hidden">
                        <img src={bgW} alt="brand logo" className="login background w-[54%] lg:hidden mt-10" />
                    </div>
                    <div className="h-screen xl:col-span-7 xl:flex items-center hidden xl:relative">
                        <div className="w-full h-[64vh] bg-prime flex lg:hidden items-start lg:items-center justify-center"></div>
                        <div className="w-full h-full hidden lg:flex items-start lg:items-center justify-center">
                            <img src={bgLogin} alt="brand logo" className="login background" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}